// extracted by mini-css-extract-plugin
export var arrowButton = "Carousel-module--arrowButton--LNNBU";
export var arrowDisabled = "Carousel-module--arrowDisabled--Nw9WJ";
export var carouselArrows = "Carousel-module--carouselArrows--n8Prg";
export var carouselContainer = "Carousel-module--carouselContainer--trdf1";
export var carouselControls = "Carousel-module--carouselControls--HffBC";
export var carouselDots = "Carousel-module--carouselDots--GVNUW";
export var carouselSlide = "Carousel-module--carouselSlide--XBkUX";
export var carouselTrack = "Carousel-module--carouselTrack--kyE-d";
export var carouselWrapper = "Carousel-module--carouselWrapper--a6Jc7";
export var controlsBottomRight = "Carousel-module--controlsBottomRight--D347A";
export var controlsCenter = "Carousel-module--controlsCenter--vi-tZ";
export var dot = "Carousel-module--dot--ihVz6";
export var dotActive = "Carousel-module--dotActive--22f0l";
export var fadeIn = "Carousel-module--fadeIn--B8Ji-";